import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { request } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // Initial loading state
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async (background = false) => {
    if (!background) setLoading(true);
    try {
      const userData = await request('/api/me', 'GET');
      setUser(userData);
    } catch (e) {
      setUser(null);
    } finally {
      if (!background) setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth(false); // Initial check
  }, [checkAuth]);

  const value = {
    user,
    loading,
    checkAuth,
    setUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
